import { ActionTree } from 'vuex';
import { RootMutations, RootState } from '@/store/types';
import { ServiceFactory } from '@/service/ServiceFactory';
import { LoginDto } from '@/dto/auth/LoginDto';

const AuthService = ServiceFactory.get('auth');

export const actions: ActionTree<any, RootState> = {
  async signIn({ commit }, loginDto: LoginDto): Promise<any> {
    try {
      const { data } = await AuthService.login(loginDto);
      if (data.role !== 'admin' && data.role !== 'provider') throw new Error('Access is denied. You may not have the appropriate permissions to access the admin part!');
      commit(RootMutations.SET_USER, data);
    } catch (e) {
      throw e;
    }
  },
  async logout({ commit }, id: string | number): Promise<void> {
    try {
      const { data } = await AuthService.logout(id);
      commit(RootMutations.REMOVE_USER);
    } catch (e) {
      throw e;
    }
  }
};
